<template>
  <div>
    <a-button type="primary" @click="openAddDialog" style="margin-bottom: 16px"
      >添加广告源</a-button
    >
    <x-table
      :columns="columns"
      :data-source="tableData"
      :loading="loading"
      rowKey="id"
      bordered
      :pagination="false"
    >
      <template #action="{ record }">
        <a @click="openEditDialog(record)">编辑</a>
        <a-divider type="vertical" />
        <a @click="deleteAdsSource(record)">删除</a>
      </template>
    </x-table>
    <a-pagination
      :current="pageNo"
      :page-size="pageSize"
      :total="total"
      @change="onPageChange"
      style="margin-top: 16px; text-align: right"
    />
  </div>
  <x-dialog
    :visible="addDialogVisible"
    title="添加广告源"
    xWidth="400px"
    @cancel="closeAddDialog"
    @confirm="handleAddAdsSource"
    :confirmLoading="addLoading"
  >
    <a-form
      layout="vertical"
      :model="addForm"
      :rules="addFormRules"
      ref="addFormRef"
    >
      <a-form-item label="归属" name="remark" required>
        <a-select v-model:value="addForm.remark" placeholder="请选择归属" allowClear>
          <a-select-option value="第三方">第三方</a-select-option>
          <a-select-option value="自营">自营</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="广告地址" name="url" required>
        <a-input v-model:value="addForm.url" placeholder="请输入广告地址" />
      </a-form-item>
    </a-form>
  </x-dialog>
</template>

<script setup lang="ts">
import { ref, computed, onMounted, watch } from "vue";
import { message, Modal } from "ant-design-vue";
import XTable from "@/components/XATable.vue";
import XDialog from "@/components/XDialog.vue";
import { adsSourceList, adsSourceCreate, adsSourceDel } from "@/api/api";
import type { FormInstance } from "ant-design-vue";

const tableData = ref([]);
const loading = ref(false);
const pageNo = ref(1);
const pageSize = ref(10);
const total = ref(0);
const addDialogVisible = ref(false);
const addForm = ref({
  id: undefined,
  remark: "",
  url: "",
});
const addFormRef = ref<FormInstance>();
const addLoading = ref(false);
const addFormRules = {
  remark: [{ required: true, message: "请输入广告标题" }],
  url: [{ required: true, message: "请输入广告地址" }],
};

const props = defineProps({
  isRefresh: {
    type: Boolean,
    default: false,
  },
  dateTime: {
    type: String,
    default: "",
  },
});

watch(() => props.isRefresh, (newVal: boolean) => {
  if (newVal) {
    getList();
  }
});

watch(() => props.dateTime, (newVal: string) => {
  //console.log(newVal);
  if (newVal) {
    getList();
  }
});

const columns = ref([
  {
    title: "ID",
    dataIndex: "id",
    key: "id",
    width: 80,
  },
  {
    title: "归属",
    dataIndex: "remark",
    key: "remark",
  },
  {
    title: "广告地址",
    dataIndex: "url",
    key: "url",
  },
  //   {
  //     title: "创建时间",
  //     dataIndex: "createdAt",
  //     key: "createdAt",
  //     width: 180,
  //     isAllTime: true,
  //   },
    {
      title: "操作",
      dataIndex: "action",
      key: "action",
      width: 150,
    },
]);

const openAddDialog = () => {
  addDialogVisible.value = true;
  addForm.value = { id: undefined, remark: "", url: "" };
  addFormRef.value?.resetFields();
};

const closeAddDialog = () => {
  addDialogVisible.value = false;
};

const openEditDialog = (record: any) => {
  addDialogVisible.value = true;
  addForm.value = { ...record };
  addFormRef.value?.resetFields();
};

const handleAddAdsSource = async () => {
  if (!addFormRef.value) return;
  try {
    await addFormRef.value.validate();
    addLoading.value = true;
    const params = { ...addForm.value };
    const res = await adsSourceCreate(params);
    if (res.code === "200") {
      message.success(addForm.value.id ? "修改成功" : "添加成功");
      closeAddDialog();
      getList();
    } else {
      message.error(res.msg);
    }
  } catch (e) {
    // 校验失败自动提示
  } finally {
    addLoading.value = false;
  }
};

const deleteAdsSource = (record: any) => {
  Modal.confirm({
    title: "确认删除该广告源？",
    content: `归属：${record.remark}`,
    okText: "确定",
    cancelText: "取消",
    onOk: async () => {
      try {
        const res = await adsSourceDel({ id: record.id });
        if (res.code === "200") {
          message.success("删除成功");
          getList();
        } else {
          message.error(res.msg || "删除失败");
        }
      } catch (error) {
        message.error("删除失败");
        console.error("删除广告源失败:", error);
      }
    },
  });
};

onMounted(() => {
  getList();
});

const onPageChange = (page: number) => {
  pageNo.value = page;
  getList();
};

const getList = () => {
  loading.value = true;
  adsSourceList({
    pageNo: pageNo.value,
    pageSize: pageSize.value,
    dateTime: props.dateTime,
  })
    .then((res) => {
      tableData.value = res.data.records || [];
      total.value = res.data.total || 0;
    })
    .catch((e) => {
      message.error("获取广告源列表失败");
    })
    .finally(() => {
      loading.value = false;
    });
};
</script>
